var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('discover-catlist'),_c('keep-alive',[(_vm.$route.path.includes('/discover'))?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }